// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hmHCpksHQg57iW0Xo5EM{background:var(--background-neutral-default);border-radius:6px;justify-content:center;align-items:center;width:24px;height:24px;font-size:12px;font-weight:500;display:flex}.hmHCpksHQg57iW0Xo5EM.sH2cbXGDeFcm93X_vjg8{background:var(--background-primary-inverted-primary)}.hmHCpksHQg57iW0Xo5EM.RmukP0bSWQepobZ5fKiZ{background:var(--background-neutral-default)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockNumber": `hmHCpksHQg57iW0Xo5EM`,
	"blockNumberOpen": `sH2cbXGDeFcm93X_vjg8`,
	"blockNumberClosed": `RmukP0bSWQepobZ5fKiZ`
};
export default ___CSS_LOADER_EXPORT___;
